import DcddActiveUserTable from "./page/DcddActiveUserTable";


const DcddActiveUserReport:React.FC = () =>{
    return(
        <>
        <DcddActiveUserTable/>
        </>
    )
};
export default DcddActiveUserReport